export default "__VITE_ASSET__BqPJIrJ8__"